'use strict';

var Params = function Params(containerWidth) {
  var padding = {
    top: 10,
    bottom: 10,
    left: 20,
    right: 20
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = 30;
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: height + padding.top + padding.bottom,
    padding: padding,
    forceHeight: true,
    maxGroupWidth: 30
  };
};
module.exports = Params;